<template>
  <div :class="cardClasses">
    <div v-if="$slots.header || title" class="bert-card-header">
      <slot name="header">
        <h3 v-if="title" class="bert-card-title">{{ title }}</h3>
      </slot>
    </div>
    
    <div v-if="$slots.default" class="bert-card-body" :class="{ 'bert-card-body--no-padding': noPadding }">
      <slot></slot>
    </div>
    
    <div v-if="$slots.footer" class="bert-card-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BertCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'elevated', 'outlined', 'filled'].includes(value)
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value)
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    hoverable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cardClasses() {
      return [
        'bert-card',
        `bert-card--${this.variant}`,
        `bert-card--${this.size}`,
        {
          'bert-card--hoverable': this.hoverable
        }
      ]
    }
  }
}
</script>

<style scoped>
.bert-card {
  background-color: white;
  border-radius: var(--radius-lg);
  overflow: hidden;
  transition: all var(--transition-base);
}

/* Variants */
.bert-card--default {
  border: 1px solid var(--neutral-200);
}

.bert-card--elevated {
  box-shadow: var(--shadow-md);
  border: 1px solid var(--neutral-100);
}

.bert-card--outlined {
  border: 2px solid var(--neutral-300);
}

.bert-card--filled {
  background-color: var(--neutral-50);
  border: 1px solid var(--neutral-200);
}

/* Sizes */
.bert-card--sm {
  border-radius: var(--radius-md);
}

.bert-card--md {
  border-radius: var(--radius-lg);
}

.bert-card--lg {
  border-radius: var(--radius-xl);
}

/* Hoverable */
.bert-card--hoverable {
  cursor: pointer;
}

.bert-card--hoverable:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.bert-card-header {
  padding: var(--space-6);
  border-bottom: 1px solid var(--neutral-200);
  background-color: var(--neutral-50);
}

.bert-card--sm .bert-card-header {
  padding: var(--space-4);
}

.bert-card--lg .bert-card-header {
  padding: var(--space-8);
}

.bert-card-title {
  margin: 0;
  font-size: var(--text-lg);
  font-weight: var(--font-semibold);
  color: var(--neutral-800);
}

.bert-card--sm .bert-card-title {
  font-size: var(--text-base);
}

.bert-card--lg .bert-card-title {
  font-size: var(--text-xl);
}

.bert-card-body {
  padding: var(--space-6);
}

.bert-card--sm .bert-card-body {
  padding: var(--space-4);
}

.bert-card--lg .bert-card-body {
  padding: var(--space-8);
}

.bert-card-body--no-padding {
  padding: 0;
}

.bert-card-footer {
  padding: var(--space-6);
  border-top: 1px solid var(--neutral-200);
  background-color: var(--neutral-50);
}

.bert-card--sm .bert-card-footer {
  padding: var(--space-4);
}

.bert-card--lg .bert-card-footer {
  padding: var(--space-8);
}
</style>